<template>
  <div class="list-item">
    <div class="list-item-option" @click="handleTitleClick">
      <div class="title overh" :title="data.title">{{ data.title }}</div>
      <div class="bztag">
        <template v-if="data.implementationStatus">
          <el-tag v-if="data.implementationStatus.indexOf('废止') !== -1" type="danger">{{
              data.implementationStatus
            }}
          </el-tag>
          <el-tag v-else type="success">{{ data.implementationStatus }}</el-tag>
        </template>
        <template v-else>
          <el-tag type="success">{{ data.platSource }}</el-tag>
        </template>
      </div>
    </div>
    <AdsVue ref="ads" @handleClose="handleTitleClick"/>
  </div>
</template>

<script>
import AdsVue from "@components/sys/ads";
import {ToText, toTime} from "../assets/js/news.js";

export default {
  components: {
    AdsVue,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    detail: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    commonTime() {
      if (this.data.releaseTime) {
        return this.data.releaseTime.indexOf("-") > -1
          ? this.data.releaseTime.split(" ")[0]
          : toTime(this.data.releaseTime, false);
      }
    },
  },
  mounted() {
  },
  methods: {
    handleTitleClick(item) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "标准规范-详情",
      });
      this.$ajax({
        type: "get",
        url: `${this.$store.state.api.baseWebUrl}` + this.detail,
        data: {
          id: this.data.id,
        },
        callback: (data) => {
          if (data.isView) {
            if (data.httpUrl.indexOf("<a") != -1) {
              let href = data.httpUrl.split('href="')[1].split('">')[0];
              window.open(href);
            } else {
              window.open(data.httpUrl);
            }
          } else {
            this.loading.close();
            this.$refs.ads.showAdsDialog({
              relationId: item.id ? item.id : this.data.id,
              relationType: this.retype,
            });
          }
        },
      });
    },
  },
};
</script>

<style scoped lang="scss">
.list-item {
  line-height: 32px;
  &-option {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #FFFFFF;
    cursor: pointer;

    .title {
      color: #242424;
      font-size: 14px;
      width: 220px;
    }

    .bztag {
      width: 78px;
      font-weight: 400;
      font-size: 14px;
      color: #333333;
      line-height: 28px;
      margin-left: 20px;
      display: flex;
      justify-content: flex-end;
    }
  }
  ::v-deep{
    .el-tag{
      height: 20px;
      line-height: 20px;
    }
  }
}
</style>
